import CustomBadge from './CustomBadge';

export default CustomBadge;
